

export const isChatHours = async settings => {
  const dt = new Date();
  // Check if daylight savings time
  let dst = false;
  const currentEasternTime = new Date().toLocaleString("en-US", { timeZone: "America/New_York", timeZoneName: "long" });
  if (currentEasternTime.includes("Daylight")) {
    dst = true;
  } else {
    dst = false;
  }


  const offset = dst ? -4 * 60 : -5 * 60;
  //convert from UTC to EST
  dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
  const estDate = new Date(dt.getTime() + offset * 60 * 1000);
  console.log(estDate, 'est');
  const day = estDate.getDay();
  const hours = estDate.getHours();
  const minutes = estDate.getMinutes();

  // ====== HOLIDAYS ======
  const date = estDate.getDate();
  const month = estDate.getMonth(); // 0 indexed. 0 = January
  const year = estDate.getFullYear();

  // closed on Sunday
  if (day === 0) return false;

  // closed on Saturday
  // TEMPORARY: Comment out to stay open on Saturday
  if (day === 6) return false;

  //2022 Holiday Office Hours

  if (date === 24 && month === 11) {
    return false;
  }
  if (date === 31 && month === 11) {
    //return false;
  }
  if (date === 1 && month === 0) {
    return false;
  }
  if (date === 28 && month === 4) {
    return false;
  }
  if (date === 30 && month === 4) {
    return false;
  }
  if (date === 4 && month === 6) {
    return false;
  }
  if (date === 5 && month === 8) {
    return false;
  }

  if (date === 24 && month === 10) {
    return false;
  }
  if (date === 26 && month === 11) {
    return false;
  }

  let sHour = 9;
  let sMin = 0;
  let eHour = 18;
  let eMin = 30;

  var start = sHour * 60 + sMin;
  var end = eHour * 60 + eMin;
  var time = hours * 60 + minutes;


  // check if current time is inclusive to startTime & endTime
  return time >= start && time < end;
};
